import { useMutation, useQuery } from "@tanstack/react-query";
import planService from "../../services/planService";

// Queries
export const useGetPlan = (queryOptions = {}) => {
  return useQuery(["plan"], planService.show, {
    refetchOnMount: "always", // Always refetch when component mounts
    staleTime: 0, // Data is immediately stale, so it always refetches fresh data
    ...queryOptions,
  });
};

export const useEditPlan = (queryOptions = {}) => {
  return useQuery(["plan", "edit"], planService.edit, {
    refetchOnMount: "always", // Always refetch when component mounts
    ...queryOptions,
  });
};

// Mutations
export const useUpdatePlan = (mutationOptions = {}) => {
  return useMutation(planService.update, mutationOptions);
};

export const useConfirmPlan = (mutationOptions = {}) => {
  return useMutation(planService.confirm, mutationOptions);
};
